<template>
    <div class="four-oh-four" @click="goBack">
        <div class="four-oh-four__top">
            <img class="four-oh-four__image" :src="'/images/leasitting.gif'">
        </div>

        <div class="four-oh-four__bottom">
            <h1 class="four-oh-four__title">
                -- Nothing To See Here --
            </h1>

            <p class="four-oh-four__instruction">
                please move along
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    methods: {
    // go back to the home screen
        goBack() {
            this.$router.push({ name: 'fotodatenbank' });
        }
    }
}
</script>

<style scoped lang="scss">
.four-oh-four{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
}

.four-oh-four__top{
    display: flex;
    flex-direction: column;
    margin-bottom: 2rem;

    @include large {
        margin-bottom: 4rem;
    }
}

.four-oh-four__image{
    width: 12.5rem;

    @include medium {
        width: 25rem;
    }

    @include extra-large {
        width: 37.5rem;
    }
}

.four-oh-four__bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.four-oh-four__title{
    font-size: 1.75rem;
    margin-bottom: 1rem;

    @include extra-small {
        font-size: 1.5rem;
    }

    @include medium {
        font-size: 3rem;
    }

    @include extra-large {
        font-size: 6.25rem;
    }
}

.four-oh-four__instruction{
    font-size: 1.25rem;

    @include medium {
        font-size: 1.5rem;
    }

    @include extra-large {
        font-size: 2rem;
    }
}
</style>
